import { IMPORT_START_LIST } from 'src/modules/StartList/constants';

import { errorsStore } from 'stores';

export const closeImportErrorsModal = () => {
  errorsStore.clearError(IMPORT_START_LIST);
};
